const errors = {
  CodeMismatchException:
    "You entered the incorrect verification code. Please try again.",
  LimitExceededException: "Attempt limit exceeded, please try after some time.",
  NotAuthorizedException: "Wrong email or password.",
  InvalidParameterException: "Custom auth lambda trigger is not configured for the user pool.",
  UserNotFoundException: "User does not exist.",
};

export const getApiErrorMessage = (text) => {
  const prefix = String(text)?.split(":");

  if (errors[prefix[0]]) {
    return errors[prefix[0]];
  }

  return String(text);
};
